var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-invoice"},[_c('add-form-new',{key:_vm.$route.params.value})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }